import React from 'react';
import PropTypes from 'prop-types';

import TableCell from '@material-ui/core/TableCell';

import { get } from 'lodash-es';

import CurrencyNumberFormat from '../../Common/CurrencyNumberFormatComponent';
import PercentNumberFormatComponent from '../../Common/PercentNumberFormatComponent';
import HybridContent from './HybridContent';

// import _ from 'lodash';

const OfferCell = props => {
  const { type, data, strings } = props;
  const getFormatedData = () => {
    const value = get(data, 'value');
    const format = get(data, 'format');
    switch (format) {
      case 'percent': {
        try {
          const formatedValue = Number(value) * 100;
          return <PercentNumberFormatComponent value={formatedValue} displayType="text" />;
        } catch (error) {
          return value;
        }
      }
      case 'currency':
        return <CurrencyNumberFormat value={value} displayType="text" />;
      default:
        return <span className="label">{get(strings, value, value)}</span>;
    }
  };
  switch (type) {
    case 'number':
      return <TableCell>{data}</TableCell>;

    case 'currency':
      return (
        <TableCell className="offer-cell">
          {data && typeof data !== 'object' ? (
            <CurrencyNumberFormat value={data} displayType="text" />
          ) : (
            getFormatedData()
          )}
        </TableCell>
      );

    case 'hybrid': {
      return <HybridContent>{data}</HybridContent>;
    }

    default:
      return (
        <TableCell className="offer-cell">
          <span className="label">{get(strings, data, data)}</span>
        </TableCell>
      );
  }
};

OfferCell.propTypes = {
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  type: PropTypes.oneOf(['string', 'number', 'date', 'boolean', 'currency', 'hybrid']),
  strings: PropTypes.object, // eslint-disable-line
};

OfferCell.defaultProps = {
  data: undefined,
  type: 'string',
};

export default OfferCell;
